<template>
	<div class="mb-1 clearfix">
		<div class="alert pb-2 pt-2 pl-2 pr-2 text-white" :class="passClass">
			<div class="float-left mr-4">
				<b-icon :icon="iconName" style="width: 30px; height: 30px"></b-icon>
			</div>
			<p class="mb-0 mt-0 lh-1 font-bold">{{ settings.caption }}</p>
			<p class="mb-0 mt-0 lh-1">{{ passMessage && gradeMessage ? passMessage + ', ' + gradeMessage : (passMessage || gradeMessage) }}</p>
		</div>
	</div>
</template>

<script>

export default {
	components: {
	},
	props: {
		settings: Object
	},
	data() {
		return {
		};
	},
	mounted() {
	},
	watch: {
	},
	computed: {
		// When the report data element has a "passing grade" cutoff
		// configured, the many-valued grade collapses to a pass/fail
		// dichotomy (0 or 1) - otherwise this stays null.
		hasGradeDichotomy() {
			return this.settings.gradepassed !== null && this.settings.gradepassed !== undefined;
		},
		gradeMessage() {
			if(!('ready' in this.settings) || !this.settings.ready){
				return '';
			}
			if(!this.settings.grade){
				return '';
			}
			if(this.settings.gradedate){
				return this.$t('grade-colon-{n}-on-{d}' , {n: this.settings.grade, d: this.$datetime.timestampToDate(this.settings.gradedate)});
			}
			return this.$t('grade-colon-{n}' , {n: this.settings.grade});
		},
		passMessage() {
			if(!('ready' in this.settings) || !this.settings.ready){
				return '...';
			}
			// When a passing-grade cutoff is configured, whatever is bound
			// as the primary value (eg. a response count) isn't a real pass
			// date at all - the dichotomy above already covers pass/fail,
			// so there's nothing meaningful to say here.
			if(this.hasGradeDichotomy){
				return '';
			}
			if(this.settings.value !== 0){
				return this.$t('passed-colon-{n}' , {n: this.$datetime.timestampToDate(this.settings.value)});
			}
			return this.$t('not-passed');
		},
		passType() {
			if(!('ready' in this.settings) || !this.settings.ready){
				return '';
			}
			if(this.settings.value !== 0){
				return 'pass';
			}
			return 'fail';
		},
		passClass() {
			if(!('ready' in this.settings) || !this.settings.ready){
				return 'skeleton midnight muted';
			}
			if(this.hasGradeDichotomy){
				return this.settings.gradepassed ? "bg-success" : "bg-danger";
			}
			if (this.settings.value !== 0) {
				return "bg-success";
			} else {
				return "bg-danger";
			}
		},
		iconName() {
			if(!('ready' in this.settings) || !this.settings.ready){
				return 'circle-fill';
			}
			const passed = this.hasGradeDichotomy ? !!this.settings.gradepassed : (this.settings.value !== 0);
			return passed ? "check-circle-fill" : "x-circle-fill";
		}
	}
};
</script>
